import { default as dayjsImport } from 'dayjs'
import type { Dayjs } from 'dayjs'
import advancedFormat from 'dayjs/plugin/advancedFormat'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import relativeTime from 'dayjs/plugin/relativeTime'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import isBetween from 'dayjs/plugin/isBetween'
import quarterOfYear from 'dayjs/plugin/quarterOfYear'
import duration from 'dayjs/plugin/duration'
import isoWeek from 'dayjs/plugin/isoWeek'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import minMax from 'dayjs/plugin/minMax'
import type { IPP_SUPPORTED_LOCALE } from '../intl'

dayjsImport.extend(advancedFormat)
dayjsImport.extend(utc)
dayjsImport.extend(timezone)
dayjsImport.extend(duration)
dayjsImport.extend(relativeTime)
dayjsImport.extend(localizedFormat)
dayjsImport.extend(customParseFormat)
dayjsImport.extend(isBetween)
dayjsImport.extend(quarterOfYear)
dayjsImport.extend(isoWeek)
dayjsImport.extend(isSameOrBefore)
dayjsImport.extend(isSameOrAfter)
dayjsImport.extend(minMax)

export const dayjs = dayjsImport
export { Dayjs }

// Anything dayjs() accepts as a single instant. Shared by the datetime helpers
// so callers can pass a raw string/epoch/Date without pre-parsing.
export type DateInput = string | number | Date | Dayjs

// Sanctioned dayjs locale codes the app resolves to (dayjs ships `locale(name:
// string)` with no exhaustive locale-name union type). Keep this closed so an
// unmapped locale or a typo fails type-check instead of silently loading 'en'.
export type DayjsLocale = 'en' | 'es' | 'fr'

export const DAYJS_LOCALE_MAPPING = {
  ['es-ES']: 'es',
  ['es-US']: 'es',
  ['en-US']: 'en',
  ['fr-FR']: 'fr',
  ['fr-CA']: 'fr',
} as const satisfies Record<IPP_SUPPORTED_LOCALE, DayjsLocale>
